export const TEAM_BRAND_ASSETS = [
  { target: 'logo', field: 'brand_logo_url', label: '团队 Logo', title: 'Logo 图标', width: 512, height: 512, maxBytes: 1024 * 1024, sizeLabel: '1MB', types: ['image/png', 'image/webp'], typeLabel: 'PNG 或 WebP', usage: '登录页、收起的导航栏等方形品牌图标。' },
  { target: 'wordmark', field: 'brand_wordmark_url', label: '团队字标', title: '品牌字标', width: 600, height: 160, maxBytes: 1024 * 1024, sizeLabel: '1MB', types: ['image/png', 'image/webp'], typeLabel: 'PNG 或 WebP', usage: '替换登录页、首页和展开导航中的品牌文字。' },
  { target: 'favicon', field: 'brand_favicon_url', label: '浏览器图标', title: '浏览器图标', width: 64, height: 64, maxBytes: 100 * 1024, sizeLabel: '100KB', types: ['image/png'], typeLabel: 'PNG', usage: '浏览器标签页图标；未设置时使用团队 Logo。' },
];

export async function validateTeamBrandImage(file, spec) {
  if (!spec.types.includes(file.type)) throw new Error(`${spec.label}仅支持 ${spec.typeLabel} 图片`);
  if (file.size > spec.maxBytes) throw new Error(`${spec.label}不能超过 ${spec.sizeLabel}`);
  const url = URL.createObjectURL(file);
  try {
    const image = await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('图片无法读取，请重新导出后上传'));
      image.src = url;
    });
    if (image.naturalWidth !== spec.width || image.naturalHeight !== spec.height) {
      throw new Error(`${spec.label}必须为 ${spec.width} × ${spec.height} 像素，当前为 ${image.naturalWidth} × ${image.naturalHeight} 像素`);
    }
    const canvas = document.createElement('canvas');
    canvas.width = spec.width;
    canvas.height = spec.height;
    let pixels;
    try {
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) throw new Error('Canvas unavailable');
      context.drawImage(image, 0, 0);
      pixels = context.getImageData(0, 0, spec.width, spec.height).data;
    } catch {
      throw new Error('无法检查图片透明背景，请重新导出后重试');
    }
    validateBrandTransparency(pixels, spec.width, spec.height);
  } finally {
    URL.revokeObjectURL(url);
  }
}

// Keep these thresholds aligned with the API TransparentBrandImage rule.
// A stray transparent pixel or a translucent solid rectangle is not a transparent background.
export function validateBrandTransparency(pixels, width, height) {
  let transparent = 0;
  let transparentEdge = 0;
  let visible = false;
  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      const alpha = pixels[(y * width + x) * 4 + 3];
      if (alpha >= 128) visible = true;
      if (alpha === 0) {
        transparent += 1;
        if (x === 0 || y === 0 || x === width - 1 || y === height - 1) transparentEdge += 1;
      }
    }
  }
  if (!visible) throw new Error('图片没有清晰可见的图案，请保留 Logo 或文字后重新导出');
  if (transparent < width * height * 0.01 || transparentEdge < (2 * width + 2 * height - 4) * 0.5) {
    throw new Error('请上传透明底图片：去掉白色或其他底色，保留图案四周的透明区域，再导出 PNG 或 WebP');
  }
}
